import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureIntervention, deleteCaptureIntervention, getCaptureInterventions, updateCaptureIntervention } from "../../api/captures/intervention";
import { InterventionForm } from "../../types/forms/capture";

export const useCaptureIntervention = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "interventions"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureInterventions(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: InterventionForm) => createCaptureIntervention(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ interventionId, values }: { interventionId: number; values: InterventionForm }) => updateCaptureIntervention(captureId, interventionId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (interventionId: number) => deleteCaptureIntervention(captureId, interventionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    interventionsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createIntervention: createMutation.mutateAsync,
    updateIntervention: updateMutation.mutateAsync,
    deleteIntervention: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
